export default "__VITE_ASSET__36e8d764__"